var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoticeInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6004 9.99844C19.6004 15.3004 15.3023 19.5984 10.0004 19.5984C4.69846 19.5984 0.400391 15.3004 0.400391 9.99844C0.400391 4.6965 4.69846 0.398438 10.0004 0.398438C15.3023 0.398438 19.6004 4.6965 19.6004 9.99844ZM11.2004 14.7984C11.2004 15.4612 10.6631 15.9984 10.0004 15.9984C9.33765 15.9984 8.80039 15.4612 8.80039 14.7984C8.80039 14.1357 9.33765 13.5984 10.0004 13.5984C10.6631 13.5984 11.2004 14.1357 11.2004 14.7984ZM10.0004 3.99844C9.33765 3.99844 8.80039 4.5357 8.80039 5.19844V9.99844C8.80039 10.6612 9.33765 11.1984 10.0004 11.1984C10.6631 11.1984 11.2004 10.6612 11.2004 9.99844V5.19844C11.2004 4.5357 10.6631 3.99844 10.0004 3.99844Z",
    fill: "#00AEEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoticeInfoIcon);
export default __webpack_public_path__ + "static/media/NoticeInfoIcon.fe17bae01e8dab62dd2f8d78cf4a839b.svg";
export { ForwardRef as ReactComponent };